var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlug(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 9L16.5 12.5M9.785 6L18 14.215L15.946 16.269C15.4105 16.8259 14.7694 17.2704 14.06 17.5765C13.3507 17.8827 12.5874 18.0442 11.8149 18.0518C11.0424 18.0594 10.2761 17.9128 9.56088 17.6207C8.84567 17.3285 8.19592 16.8967 7.64963 16.3504C7.10334 15.8041 6.67148 15.1543 6.37934 14.4391C6.08719 13.7239 5.94062 12.9576 5.9482 12.1851C5.95577 11.4126 6.11735 10.6493 6.42347 9.93997C6.72959 9.23063 7.1741 8.58947 7.731 8.054L9.785 6ZM4 20L7.5 16.5L4 20ZM15 4L11.5 7.5L15 4Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlug);
export default __webpack_public_path__ + "static/media/Plug.fb1c0e09b5190baa49de992c3c5cec8e.svg";
export { ForwardRef as ReactComponent };